module.exports = __webpack_public_path__ + "static/media/chevron_line_stroke_down.29564349.svg";